/**
 * Função para obter o IP público da máquina do usuário
 * @returns Promise<string> - IP público da máquina
 */
export const getPublicIP = async (): Promise<string> => {
  try {
    // Usando um serviço público para obter o IP
    const response = await fetch('https://api.ipify.org?format=json')
    const data = await response.json()
    return data.ip
  } catch (error) {
    console.warn('Erro ao obter IP público:', error)
    // Fallback para um IP padrão em caso de erro
    return ''
  }
}
